module.exports = __webpack_public_path__ + "img/logo9.a5c08b9c.png";